import { Component, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { AuthService } from "./../../shared/models/auth.service";
import { KickbackService } from "./../models/kickback.service";
import { InstanceService } from "../../instance/models/instance.service";
import { CompanyService } from "../../company/models/company.service";
import { VehicleService } from "./../../vehicle/models/vehicle.service";
import { SharedVehicleGroupService } from "./../../sharedvehiclegroup/models/sharedvehiclegroup.service";
import { OrganizationService } from "./../../organization/models/organization.service";
import { CustomerService } from "../../customer/models/customer.service";
import { ContractTypeGroupService } from "./../../contracttypegroup/models/contracttypegroup.service";
import { FlatPickrDirective } from "./../../plugins/flatpickr/flatpickr.directive";
import { FlatPickrModel } from "./../../plugins/flatpickr/flatpickr.model";
import {
  KickbackModel,
  KickbackReportResult
} from "./../models/kickback.model";
import {
  WeGoConfig,
  RoleLevel,
  PermissionType,
  ApplicationRouteURL
} from "../../shared/config";
import {
  DropdownModel,
  ReportFilterModel
} from "../../report/models/report-filter.model";

@Component({
  selector: "wego-kickback-report",
  template: require('../views/kickback.component.html'),
  styles: [
    `.border-kickback {
    border: 1px solid #E0E0E0;
    padding: 5px 0px;
  }`
  ],
  providers: [
    CustomerService,
    InstanceService,
    CompanyService,
    OrganizationService,
    SharedVehicleGroupService,
    VehicleService,
    ContractTypeGroupService,
    KickbackService
  ]
})
export class KickbackComponent implements OnInit {
  // @ViewChild("flatPickrConfigFromDate")
  // public flatPickrConfigFromDate: FlatPickrDirective;

  // @ViewChild("flatPickrConfigToDate")
  // public flatPickrConfigToDate: FlatPickrDirective;

  // public dateFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
  // model: KickbackModel;
  // KickbackList: KickbackModel[];

  // flatPickrConfigFrom: FlatPickrModel;
  // flatPickrConfigTo: FlatPickrModel;
  // permissionType: string;
  // apiErrorMsg: string;
  // pageName: string;
  // DataListModel: DataListModel;
  // public listOfFilterRecord: any[];

  isValidSearch: boolean = false;
  urlDefaultPage: string;
  reportName: string;
  roleLevel = RoleLevel;
  isLoading: boolean;
  isExport: boolean = false;
  errorModel: any;
  errorMessage: string;

  customerList: DropdownModel[];
  instanceList: DropdownModel[];
  companyList: DropdownModel[];
  sharedVehicleGroupList: DropdownModel[];
  organizationList: DropdownModel[];
  vehicleList: DropdownModel[];
  contractTypeGroupList: DropdownModel[];
  kickbackReportResult: KickbackReportResult[];

  constructor(
    private kickbackReportService: KickbackService,
    private authService: AuthService,
    private customerService: CustomerService,
    private instanceService: InstanceService,
    private companyService: CompanyService,
    private organizationService: OrganizationService,
    private sharedVehicleGroupService: SharedVehicleGroupService,
    private vehicleService: VehicleService,
    private contractTypeGroupService: ContractTypeGroupService
  ) { }

  ngOnInit() {
    this.reportName = "Kick_Back_Report";
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
  }

  public ResetValidSearch($event: any) {
    let isValidSearch: boolean = $event.isValidSearch;
    this.isValidSearch = isValidSearch;
    this.kickbackReportResult = [];
  }

  public OnSearch($event: any) {
    this.isLoading = true;
    let model: ReportFilterModel = $event.model;
    this.kickbackReportService.GetKickbackRecord(model).subscribe(
      res => {
        this.errorModel = [];
        if (!res.data) {
          this.isValidSearch = false;
          this.errorModel = res.error;
        } else {
          console.log(res.data);
          this.kickbackReportResult = res.data;
          this.isValidSearch = res.data.length > 0 ? true : false;
          if (typeof res.error === "string") {
            this.errorMessage = res.error;
          } else {
            this.errorModel = res.error;
          }
        }
        this.isLoading = false;
      },
      error => {
        this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public OnExportExcel($event: any) {
    this.isLoading = true;
    let model: ReportFilterModel = $event.model;
    this.kickbackReportService.ExportKickBackReportExcel(model).subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "KickBackReport" + new Date().toISOString() + ".xlsx";
          this.authService.DownloadXlsFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public OnExportPDF($event: any) {
    this.isLoading = true;
    let model: ReportFilterModel = $event.model;
    this.kickbackReportService.ExportKickBackReportPdf(model).subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "KickBackReport" + new Date().toISOString() + ".pdf";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/report/components/kickback.component.ts